<template>
    <div class="warehouse-list-page">
        <base-header
            class="warehouse-list-page__header"
            :titulo="translate('main_title')"
            icon="el-icon-document-add"
            :exibe-botao="false"
            iconBotaoSecundario="el-icon-upload"
            :exibeBotaoSecundarioAcao="true"
            :btnTextoAcoes="translate('actions')"
            :acoes="actions"
            @realizarAcao="chooseAction($event)"
            :iconesAcoes="true"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <search-filters @changeFilters="changeFilters" />
                <company-warehouse-list
                    v-if="filters"
                    :filters="filters"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import SearchFilters from '@/modules/warehouse/views/pages/companyWarehouseList/components/filters/index.vue';
import CompanyWarehouseList from '@/modules/warehouse/views/pages/companyWarehouseList/components/company-warehouse-list/index.vue';
import { WarehouseListActionsEnum } from '@/modules/warehouse/constants/WarehouseListActionsEnum';

import { mapGetters } from 'vuex';

    export default {
        name: 'WarehouseListPage',
        components: {
            BaseHeader,
            SearchFilters,
            CompanyWarehouseList
        },
        computed: {
            ...mapGetters(['usuarioLogado'])
        },
        mounted() {
        },
        data() {
            return {
                filters: {},
                actions: [
                    {
                        titulo: this.$t('warehouse.warehouse_list_page.batch_record'),
                        codigo: 'UPLOAD_WAREHOUSES',
                        emit: WarehouseListActionsEnum.UPLOAD_WAREHOUSES,
                        icon: 'el-icon-upload'
                    },
                    {
                        titulo: this.$t('warehouse.warehouse_list_page.view_registration_requests'),
                        codigo: 'VIEW_REGISTRATION_REQUESTS',
                        emit: WarehouseListActionsEnum.VIEW_REGISTRATION_REQUESTS,
                        icon: 'lyra-icon-dropdown-menu lyra-enviar_notas'
                    }
                ]
            };
        },
        watch: {
            '$i18n.locale': function (newLocale) {
                this.actions.forEach(action => {
                    action.titulo = this.reloadActionLabel(action.codigo);
                });
            }
        },
        methods: {
            translate(key, params = {}) {
                const base = 'warehouse.warehouse_list_page';
                return this.$t(`${base}.${key}`, params);
            },
            chooseAction(action) {
                if (action === WarehouseListActionsEnum.UPLOAD_WAREHOUSES) {
                    this.$router.push({
                        name: 'CadastrarArmazem',
                        params: { action: action }
                    });
                } else {
                    this.$router.push({
                        name: 'AcompanharCadastroArmazem'
                    });
                }
            },
            changeFilters(filters) {
                this.filters = filters;
            },
            reloadActionLabel(actionCode) {
                if (actionCode === 'UPLOAD_WAREHOUSES') {
                    return this.translate('batch_record');
                }
                if (actionCode === 'VIEW_REGISTRATION_REQUESTS') {
                    return this.translate('view_registration_requests');
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.warehouse-list-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}

</style>
